import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * @entity ANEinverstaendnisErklaerungen
 *
 **/
@Entity()
export class ANEinverstaendnisErklaerungen extends AdornisEntity {
  static override _class = 'ANEinverstaendnisErklaerungen';

  @Field(() => Boolean, { default: v => v ?? false })
  selbstverpflichtung: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  datenschutz: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  infektionsschutz: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  studentSozialversicherungspflicht: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  mitarbeiterInformation: Maybe<boolean>;
}
